$( document ).ready(function() {
    var uniqid = 0;
  SelectInput = function (element){ // dodělat s ajaxem
      this.element = element;

      this.SelectInput = $('<div class="SelectInput"><div class="selected"></div><div class="options"></div>');
      this.SelectInput.insertAfter($(this.element));
      this.options = [];
      this.selectedOption = null;
      $(this.SelectInput).width($(this.element).outerWidth());
      $(this.SelectInput).find('.options').width($(this.element).outerWidth()-2);
      this.resize = function(){
          $(this.element).show();
          $(this.SelectInput).width($(this.element).outerWidth());
          //$(this.SelectInput).height($(this.element).outerHeight());
        $(this.SelectInput).find('.options').width($(this.element).outerWidth()-2);
        $(this.element).hide();
      }
      $(this.element).hide();
      if($(this.element).attr('disabled') !== undefined) $(this.SelectInput).addClass('disabled');
      if($(this.element).hasClass('checkboxes')) {
          $(this.SelectInput).find('.selected').html('<div class=submit>keres</div>');
          $(this.SelectInput).addClass('checkboxes');
      }
      if($(this.element).hasClass('search')) {
          $(this.SelectInput).addClass('search');
      }

      var checkboxes_checked = '';
      var checkboxes_checked_n = 0;
        $(this.element).find('option').each(function (i,el){
            uniqid++;
            var option = $('<div class="option"></div>');
            if(!($(el).prev().length) && $(el).parent().prop("tagName") == "OPTGROUP"){
                var optiongroup = $('<div class="option optgroup"></div>');
                $(optiongroup).html($(el).parent().attr('label'));
                this.options.push(optiongroup);
            }
            $(option).addClass($(el).attr('class'));
            $(option).html('<label for="uniqid'+(uniqid)+'">'+$(el).html()+'</label>');
            $(option).attr('v',$(el).attr('value'));
            if($(el).attr('disabled') !== undefined) $(option).addClass('disabled');
            if($(el).attr('img')) $(option).prepend($('<img src="'+$(el).attr('img')+'">'));
            if($(el).attr('colorbox')) $(option).prepend($('<div class="colorbox" style="background-color:#'+$(el).attr('colorbox')+';">'));
            if($(el).parent().prop("tagName") == "OPTGROUP") $(option).addClass('optgitem');
            if($(el).hasClass('searchable')) $(option).find('label').addClass('searchable');
            if($(this.element).hasClass('checkboxes') && $(el).attr('disabled') === undefined){
                var checkbox = $('<input type="checkbox" name="'+$(this.element).attr('name')+'[]" id="uniqid'+(uniqid)+'" value="'+$(el).attr('value')+'">');
                $(option).prepend(checkbox);
                $(checkbox).attr('multiamount',$(el).attr('multiamount'));
                $(checkbox).attr('multilabel',$(el).attr('multilabel'));
            }
            this.options.push(option);
            if((this.selectedOption === null || $(el).attr('selected')) && !$(this.element).hasClass('checkboxes')) {
                this.selectedOption = option;
                this.selectedOptionF = this.selectedOption;
            }
            else if($(this.element).hasClass('checkboxes')) {
                if(this.selectedOption === null) {
                    this.selectedOption = option;
                    this.selectedOptionF = this.selectedOption;
                }
                if($(el).hasClass('sel')){
                    $(checkbox).attr('checked', true);

                    checkboxes_checked += (checkboxes_checked.length != 0 ? ', ' : '') + $(el).attr('multilabel');
                    checkboxes_checked_n += Number($(el).attr('multiamount'));
                }
            }
        }.bind(this));

      this.titleRecalculate = function () {
          var checked = $(this.SelectInput).find('input[type=checkbox]:checked');
          var checkboxes_checked = '';
          var checkboxes_checked_n = 0;
          if(checked.length == 0){
              $(this.SelectInput).find('.selected .option').first().html($(this.selectedOptionF)[0].outerHTML);
          } else {
              $(checked).each(function (i,el){
                    checkboxes_checked += (checkboxes_checked.length != 0 ? ', ' : '') + $(el).attr('multilabel');
                    checkboxes_checked_n += Number($(el).attr('multiamount'));
                });
                var label = $('<label></label>');
                $(this.SelectInput).find('.selected .option').html($(label).html(checkboxes_checked)/* + (checkboxes_checked_n>0 ? ' ('+checkboxes_checked_n+')': '')*/);
          }

      };


      $(this.options).each(function(i,el){
          $(this.SelectInput).find('.options').first().append($(el)[0].outerHTML);
      }.bind(this));
      $(this.SelectInput).find('.selected').first().append($(this.selectedOption)[0].outerHTML);
      if(checkboxes_checked.length != 0) {
          var label = $('<label></label>');
          $(this.SelectInput).find('.selected .option').html($(label).html(checkboxes_checked)/* + (checkboxes_checked_n>0 ? ' ('+checkboxes_checked_n+')': '')*/);
          $(this.SelectInput).find('.selected').removeClass('disabled');
          $(this.SelectInput).find('.selected .option').removeClass('disabled');
      }


      var v = $(this.selectedOption).attr('v');

      $(this.SelectInput).find('[v="'+v+'"]').addClass('active');

      if($(this.element).hasClass('checkboxes')) {
          $(this.element).attr('name','');
      }
      var _this=this;
      $(this.SelectInput).find('.selected').click(function(e){
          e.preventDefault();
          if(!$(this).parent().hasClass('disabled')) {
              if($(this).hasClass('open') && $(this).parent().hasClass('checkboxes')) $(this).parent().prev().trigger('change');
            $(this).parent().find('.options').toggleClass('open');
            $(this).toggleClass('open');
            if($(this).parent().hasClass('search')){
                $(this).parent().parent().find('.options label').show().removeClass('focus');
                $(this).parent().parent().find('.options .optgroup').show();
                if($(this).find('input').length) $(this).find('input').remove();
                else {
                    var input = $('<input type="text">');
                    $(this).append(input);
                    input.focus();
                    input.keyup(function(e){
                        var searchstring = $(this).val();
                        if(searchstring.length == 0){
                            $(this).parent().parent().find('.options label').show().removeClass('focus');
                            $(this).parent().parent().find('.options .optgroup').show();
                        } else {
                            if(e.keyCode == 13)
                            {
                                $(this).find('input').remove();
                                e.stopImmediatePropagation();
                                console.log($(this).parent().parent().find('.options .focus'));
                                $(this).parent().parent().find('.options .focus').click();
                            }
                            $(this).parent().parent().find('.options label').hide().removeClass('focus');
                            $(this).parent().parent().find('.options .optgroup').hide();
                            var searchstring = $(this).val();
                            var lookupAll = $(this).parent().parent().find('.options label.searchable').filter(function(index) {
                                return $(this).text().toLowerCase().latinise().indexOf(searchstring.toLowerCase().latinise()) >= 0;
                            });
                            lookupAll.show();
                            var lookup = lookupAll.first().parent();
                            /*var position = lookup.parent().scrollTop();// toto už se nepoužívá
                            lookup.parent().animate({
                                scrollTop:  0
                            }, 0);
                            var position2 = lookup.offset().top - lookup.parent().offset().top;
                            lookup.parent().animate({
                                scrollTop:  position
                            }, 0);
                            lookup.parent().animate({
                                scrollTop:  position2
                            }, 0);
                            $('.focus').removeClass('focus');*/
                            lookup.addClass('focus');
                        }
                    });
                }

            }

          }
      });
      var _this = this;
      $(this.SelectInput).find('.options .option').click(function(e) {

          if(!$(this).hasClass('disabled') && !$(this).hasClass('optgroup') && !$(this).parent().parent().hasClass('checkboxes')){
              $(this).parent().parent().find('.selected input').remove();
              e.preventDefault();
            $(this).parent().toggleClass('open');
            $(this).parent().parent().find('.selected').toggleClass('open');
            $(this).parent().find('.active').removeClass('active');
            $(this).addClass('active');
            $(this).parent().parent().find('.selected .option').replaceWith($(this).clone());
            $(_this.element).val($(this).attr('v'));
            $(_this.element).trigger('change');
          } else if($(this).parent().parent().hasClass('checkboxes'))
          {
              _this.titleRecalculate();
          }
      });
  }

    $('select').each(function(){
        if(!$(this).hasClass("noSelectInput"))
        {
            global.SelectInputQueue.push(new SelectInput(this));
        }
    });
    $(window).resize(function(){
        for(var i = 0; i<SelectInputQueue.length; i++)
        {
            global.SelectInputQueue[i].resize();
        }
    });

    $(document).click(function(event) {
        $('.SelectInput').each(function(i,el){

            if(!($(el).is($(event.target).closest('.SelectInput')))) {
                if($(el).find('.options').hasClass('open'))
                {
                    $(el).find('.options').removeClass('open');
                    $(el).find('.selected').removeClass('open');
                    $(el).find('.selected').find('input').remove();
                    if($(el).hasClass('checkboxes')) $(el).prev().trigger('change');
                }


            }

            for(var i = 0; i<global.SelectInputQueue.length; i++)
            {
                global.SelectInputQueue[i].resize();
            }
        });
    });
    $(document).keyup(function(e) {
        if (e.keyCode == 27) {
            $('.SelectInput').each(function(i,el){
                if($(el).find('.options').hasClass('open'))
                {
                    $(el).find('.selected').remove('input');
                    $(el).find('.options').removeClass('open');
                    $(el).find('.selected').find('input').remove();
                    if($(el).hasClass('checkboxes')) $(el).closest('form').trigger('change');
                }
            });

        }
    });

    var color_gray_60 = '#BDBDBD';
    $(".option label").filter(function() {
        return this.innerHTML.match(/(.*) \(([\d])*\)/);
    }).each(function (i,el) { el.innerHTML = el.innerHTML.replace(/(.*) \((\d+)*\)/,`$1 <em style="color:${color_gray_60};">($2)</em>`); });
});
